import basicForm from "./basicForm";

export default function closedUserGroupAccessCodeEmailForm(config = {}) {
    const { btnTxt = { submit: 'Submit', processing: 'Processing...' }, genericErrorMessage = 'An error occurred. Please try again.', ...restConfig } = config;

    return {
        ...basicForm(restConfig),
        email: '',
        accessCode: '',
        errorMessage: '',

        get btnTxt() {
            return this.isSubmitted ? btnTxt.processing : btnTxt.submit;
        },

        async submit(event) {
            event.preventDefault();
            this.errorMessage = '';
            this.isSubmitted = true;

            try {
                const formData = new FormData(event.target);
                const response = await fetch(event.target.action, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });

                const data = await response.json();

                if (data.success) {
                    window.location.reload();
                } else {
                    this.errorMessage = data.error;
                    this.isSubmitted = false;
                }
            } catch (error) {
                this.errorMessage = genericErrorMessage;
                this.isSubmitted = false;
            }
        }
    }
}
